import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage, getFormattedDate } from "helpers";
import { paymentsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

export type useWithholdsListQueryProps = {
	paidMonth: Date | string;
	paidYear: Date | string;
	fetchData: { page: number; filters: any; sortBy: { [key: string]: any } };
};

const useWithholdsListQuery = ({
	fetchData,
	paidMonth,
	paidYear,
}: useWithholdsListQueryProps) => {
	const dispatch = useDispatch();

	const { page, filters } = fetchData;

	const processingMonth = getFormattedDate({
		date: filters?.processingMonth,
		format: "MMM yyyy",
	});

	const fetchWithholdsList = () =>
		paymentsService.getWithholdsLists({
			paidMonth,
			paidYear,
			processingMonth,
			filters,
			page,
		});

	const queryResult = useQuery(
		["withholdPayments", page, filters],
		fetchWithholdsList,
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			retry: false,
			keepPreviousData: true,
			enabled: !!(paidMonth && paidYear),
		},
	);

	return queryResult;
};

export default useWithholdsListQuery;
